import { onMounted, watch } from 'vue';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { updateSentryTags } from '@/libraries/sentry';

/**
 * Composable to update Sentry tags for global user context
 *
 * Currently tracks:
 * - auth_status: User authentication status (logged_in/logged_out)
 *
 * Future additions could include:
 * - experiment_tags: Experiments active variants
 * - user_role: User role (admin, editor, pro, etc.)
 *
 */
export function useSentryTags() {
	const userStore = useUserStore();

	function updateAuthStatusTag() {
		const authStatus = userStore.isLoggedIn ? 'logged_in' : 'logged_out';
		updateSentryTags({ auth_status: authStatus });
	}

	onMounted(() => {
		watch(
			() => userStore.isLoggedIn,
			() => updateAuthStatusTag(),
			{ immediate: true }
		);
	});
}
